var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMyLocation = function SvgMyLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.696 7.522 8.518-3.365c1.063-.42 2.111.637 1.682 1.697l-3.413 8.427c-.484 1.194-2.223 1.033-2.479-.23l-.683-3.373-3.4-.672C4.648 9.755 4.49 8 5.696 7.522ZM14.508 4.9 5.99 8.266c-.465.183-.403.859.086.955l3.596.71a.5.5 0 0 1 .393.392l.723 3.57a.5.5 0 0 0 .954.087l3.413-8.426a.5.5 0 0 0-.647-.653Z",
    fill: "currentColor"
  })));
};
export default SvgMyLocation;